import React from 'react';
import Svg from '../Svg';

const IconMarkerPin03 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C8.13401 3 5 6.13401 5 10C5 12.7398 6.43931 14.2321 8.26764 15.7657C8.45903 15.9262 8.65793 16.0889 8.86116 16.255C9.94372 17.1402 11.1495 18.1262 12 19.4318C12.8505 18.1262 14.0563 17.1402 15.1388 16.255C15.3421 16.0889 15.541 15.9262 15.7324 15.7657C17.5607 14.2321 19 12.7398 19 10C19 6.13401 15.866 3 12 3ZM3 10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10C21 13.6785 18.9393 15.6862 17.0176 17.298C16.8145 17.4684 16.6153 17.6333 16.4208 17.7943C14.7005 19.2182 13.3531 20.3335 12.9806 22.1961C12.8871 22.6635 12.4767 23 12 23C11.5233 23 11.1129 22.6635 11.0194 22.1961C10.6469 20.3335 9.29947 19.2182 7.57915 17.7943C7.38469 17.6333 7.18547 17.4684 6.98236 17.298C5.06069 15.6862 3 13.6785 3 10ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z"
    />
  </Svg>
);

export default IconMarkerPin03;
